import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import TextareaAutosize from 'react-textarea-autosize'

const TakeActionPanel = ({ onSubmit }) => {
    const { t } = useTranslation()
    const [actionMessage, setActionMessage] = useState('')
    const [sendMessageError, setSendMessageError] = useState(false)

    const handleSubmit = () => {
        if (actionMessage === '') {
            setSendMessageError(true)
            return
        }
        onSubmit(actionMessage)
    }

    return (
        <div className="feedback-assigned-multiline" style={{ marginTop: 40 }}>
            <p className="feedback-take-action-title">{t('Describe how you will respond')}</p>
            <div className="feedback-textarea">
                <TextareaAutosize
                    id="action-message-textarea"
                    placeholder={t('Write your personal notes here')}
                    minRows={4}
                    value={actionMessage}
                    style={{ resize: 'none' }}
                    autoFocus
                    onChange={(e) => {
                        e.preventDefault()
                        setSendMessageError(false)
                        setActionMessage(e.target.value)
                    }}
                />
            </div>
            <p className="send-message-error" style={{ opacity: sendMessageError ? 1 : 0 }}>
                {t('youMustFillData')}
            </p>
            <div className="textarea-button" onClick={handleSubmit} id="action-text-area-button">
                <p>{t('submit')}</p>
            </div>
        </div>
    )
}

export default TakeActionPanel
